import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="handle-formatter"
export default class extends Controller {
  static targets = [ "input" ]

  connect() {
  }

  format(e) {
    if (e.key === "Backspace") {
      return;
    }
    let inputValue = this.inputTarget.value;
    let phoneNumberPattern = /^\+?\d?[- \.]?\(?(\d{3})\)?\s*[- \.]?\s*(\d{3})\s*[- \.]?\s*(\d{4})$/;

    if (phoneNumberPattern.test(inputValue)) {
      // if it's a full number, format it.
      this.inputTarget.value = inputValue.replace(phoneNumberPattern, "($1) $2-$3");
    } else if (inputValue.indexOf("@") === -1 && !(/[a-zA-Z]/.test(inputValue))) {
      // if it doesn't seem like an email yet, but it's not fully formatted, start formatting it.
      let digitsOnly = inputValue.replace(/\D/g, '');
      let countDigits = digitsOnly.length;

      if (digitsOnly[0] === "1") {
        digitsOnly = digitsOnly.slice(1);
        countDigits = digitsOnly.length;
      }

      if (countDigits == 0) {
        return;
      }

      if (countDigits < 3) {
        this.inputTarget.value = digitsOnly.replace(/(\d{0,2})/, "($1");
      } else if (countDigits < 6) {
        this.inputTarget.value = digitsOnly.replace(/(\d{0,3})(\d{0,3})/, "($1) $2");
      } else {
        this.inputTarget.value = digitsOnly.replace(/(\d{0,3})(\d{0,3})(\d{0,4})/, "($1) $2-$3");
      }
    }
  }
}